import styled from 'styled-components';
import { Breakpoints } from '../../../styled/constants';

export const HeaderWrapper = styled.div<{ $isWebView: boolean }>`
  padding-top: ${({ $isWebView }) =>
    $isWebView ? 'calc(0px + max(env(safe-area-inset-top), 40px))' : '0px'};

  @media (min-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;

export const CurrentItemSectionWrapper = styled.div<{
  $isDataRefreshing: boolean;
}>`
  ${({ $isDataRefreshing }) =>
    $isDataRefreshing
      ? {
          opacity: 0.6,
          pointerEvents: 'none'
        }
      : {
          opacity: 1,
          pointerEvents: 'auto'
        }};
  transition: opacity 0.4s ease-in-out;
`;
